/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'guiji': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M834.4 741c-40.4 0-74.9 25.6-88 61.5H333.3c-46.7 0-90.5-14.3-123.2-40.3-30.6-24.2-47.4-55.7-47.4-88.4s16.8-64.2 47.4-88.4c32.8-26 76.5-40.3 123.2-40.3h8.1v.1h352.1c129.4 0 234.7-86.5 234.7-192.7 0-106.3-105.3-192.7-234.7-192.7H279.6c-13.1-36-47.5-61.6-88-61.6-51.7 0-93.6 41.9-93.6 93.6s41.9 93.6 93.6 93.6c40.5 0 74.9-25.7 88-61.6h413.9c46.7 0 90.5 14.3 123.2 40.3 30.6 24.2 47.4 55.7 47.4 88.4s-16.8 64.2-47.4 88.4c-32.8 26-76.5 40.3-123.2 40.3h-8.1v-.1H333.3c-129.4 0-234.7 86.5-234.7 192.7s105.3 192.7 234.7 192.7h413c13 36 47.5 61.7 88 61.7 51.7 0 93.6-41.9 93.6-93.6S886.1 741 834.4 741z"/>'
  }
})
